import { ForwardedRef, forwardRef } from 'react';

export const IconPerson = forwardRef(
  (
    {
      filled,
      ...props
    }: React.SVGProps<SVGSVGElement> & { readonly filled?: boolean },
    ref: ForwardedRef<SVGSVGElement>,
  ) => {
    return (
      <svg
        ref={ref}
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
      >
        {filled ? (
          <path
            fill="currentColor"
            d="M12 11.975c-1.1 0-2-.35-2.7-1.05-.7-.7-1.05-1.6-1.05-2.7s.35-2 1.05-2.7c.7-.7 1.6-1.05 2.7-1.05s2 .35 2.7 1.05c.7.7 1.05 1.6 1.05 2.7s-.35 2-1.05 2.7c-.7.7-1.6 1.05-2.7 1.05zM4 20v-2.35c0-.634.158-1.175.475-1.625A3.05 3.05 0 015.7 15c1.117-.5 2.188-.875 3.212-1.125A12.987 12.987 0 0112 13.5c1.033 0 2.058.129 3.075.387 1.017.258 2.083.63 3.2 1.113.517.233.933.575 1.25 1.025.317.45.475.991.475 1.625V20H4z"
          ></path>
        ) : (
          <path
            fill="currentColor"
            d="M12 11.975c-1.1 0-2-.35-2.7-1.05-.7-.7-1.05-1.6-1.05-2.7s.35-2 1.05-2.7c.7-.7 1.6-1.05 2.7-1.05s2 .35 2.7 1.05c.7.7 1.05 1.6 1.05 2.7s-.35 2-1.05 2.7c-.7.7-1.6 1.05-2.7 1.05zM4 20v-2.35c0-.634.158-1.175.475-1.625A3.05 3.05 0 015.7 15c1.117-.5 2.188-.875 3.212-1.125A12.987 12.987 0 0112 13.5c1.033 0 2.058.129 3.075.387 1.017.258 2.083.63 3.2 1.113.517.233.933.575 1.25 1.025.317.45.475.991.475 1.625V20H4zm1.5-1.5h13v-.85c0-.267-.08-.521-.238-.763a1.505 1.505 0 00-.587-.537c-1.067-.517-2.042-.871-2.925-1.063-.883-.192-1.8-.287-2.75-.287s-1.875.095-2.775.287c-.9.192-1.875.546-2.925 1.063a1.42 1.42 0 00-.575.537c-.15.242-.225.496-.225.763v.85zm6.5-8.025c.65 0 1.188-.213 1.613-.638.425-.425.637-.962.637-1.612 0-.65-.213-1.188-.637-1.613-.425-.425-.963-.637-1.613-.637s-1.188.212-1.613.637c-.425.425-.637.963-.637 1.613s.213 1.187.637 1.612c.425.425.963.638 1.613.638z"
          ></path>
        )}
      </svg>
    );
  },
);

IconPerson.displayName = 'IconPerson';

export default IconPerson;
